import React from 'react';
import { XIcon } from 'lucide-react';
import { Button } from '@/Components/shadcn/button';
import { DialogTitle } from '@/Components/shadcn/dialog';

interface PopupDialogTitleProps {
    title: string;
    close: () => void;
}

function PopupDialogTitle({ title, close }: PopupDialogTitleProps): React.JSX.Element {
    return (
        <DialogTitle className="flex flex-row items-center justify-between gap-4">
            <span>{title}</span>
            <Button variant="ghost" size="icon-sm" onClick={close} data-cy="closeDialogButton" aria-label="Close">
                <XIcon />
            </Button>
        </DialogTitle>
    );
}

export default PopupDialogTitle;
